import { render } from "./PopularPage.vue?vue&type=template&id=179ac672"
import script from "./PopularPage.vue?vue&type=script&lang=js"
export * from "./PopularPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__